import React, { FC } from 'react'

import { TMenuItemButtonProps } from '../types/MenuItemButton.types'
import { MenuItemButtonView } from './MenuItemButtonView'
import { ICON_STYLE } from '../utils/MenuItemButton.utils'

export const MenuItemButton: FC<TMenuItemButtonProps> = ({
  icon,
  title,
  details,
  onClick,
  dataTestId,
}) => (
  <MenuItemButtonView
    title={title}
    details={details}
    icon={icon}
    iconStyle={ICON_STYLE}
    onClick={onClick}
    dataTestId={dataTestId}
  />
)
